import React from "react";
import ReactApexChart from "react-apexcharts";
import { CardBody } from "reactstrap";

const getChartColorsArray = (colors: any) => {
  try {
    const parsedColors = JSON.parse(colors);
    return parsedColors.map((raw: string) => {
      const value = raw.replace(/\s/g, "");
      if (value.indexOf(",") === -1) {
        let cssColor = getComputedStyle(document.documentElement).getPropertyValue(value).trim();
        return cssColor || value;
      } else {
        const [cssVar, opacity] = value.split(',');
        const baseColor = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
        return `rgba(${baseColor}, ${opacity})`;
      }
    });
  } catch (e) {
    console.error("Invalid color format for chart:", colors);
    return [];
  }
};

const TopProducts = ({ dataColors, topProducts }: any) => {
  if (!topProducts || topProducts.length === 0) {
    return <div className="text-center p-4">No data available.</div>;
  }

  const chartColors = getChartColorsArray(dataColors);
  const productNames = topProducts.map((p: any) => p.name);

  const series = [
    {
      name: 'Quantity',
      type: 'column',
      data: topProducts.map((p: any) => p.total_quantity),
      yAxisIndex: 0
    },
    {
      name: 'Revenue',
      type: 'column',
      data: topProducts.map((p: any) => p.total_revenue),
      yAxisIndex: 1
    },
  ];

  const options: any = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        columnWidth: "40%",
        horizontal: false,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 1,
      colors: ['transparent'],
    },
    xaxis: {
      categories: productNames,
      labels: {
        rotate: -45,
        style: {
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
        },
      },
    },
    yaxis: [
      {
        title: { text: "Quantity" },
        labels: { formatter: (val: number) => `${val}` },
      },
      {
        opposite: true,
        title: { text: "Revenue" },
        labels: { formatter: (val: number) => `$${val.toLocaleString()}` },
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val: number, opts: any) =>
          opts.seriesIndex === 1 ? `$${val.toLocaleString()}` : val,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetY: 10,
    },
    colors: chartColors,
    grid: {
      padding: { bottom: 40 },
    },
  };

  return (
    <CardBody>
      <div className="d-flex align-items-center mb-3">
        <h4 className="card-title flex-grow-1 mb-0">Top Products</h4>
      </div>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={400}
        className="apex-charts"
      />
    </CardBody>
  );
};

export default TopProducts;
